<template>
  <div style="margin-top: 0.5rem; padding: 0">
    <quill-editor
      ref="myQuillEditor"
      @change="onEditorChange($event)"
      style="width: 100%; margin-bottom: 1rem; padding: 0"
      :content="content"
      :id="editorId"
    >
    </quill-editor>
  </div>
</template>
<script>
export default {
  props: ["startContent", "editorId", "withoutAllReplacements"],
  data() {
    return {
      content: "",
    };
  },
  created() {
    if (this.startContent.length > 0) this.content = this.startContent;
  },

  watch: {
    startContent() {
      if (this.startContent.length > 0) this.content = this.startContent;
    },
  },

  methods: {
    // @blur="onEditorBlur($event)"
    // @focus="onEditorFocus($event)"
    // @ready="onEditorReady($event)"
    // onEditorBlur(quill) {
    //   console.log("editor blur!", quill);
    // },
    // onEditorFocus(quill) {
    //   console.log("editor focus!", quill);
    // },
    // onEditorReady(quill) {
    //   console.log("editor ready!", quill);
    // },
    onEditorChange({ html }) {
      if (html !== null && html !== undefined) {
        let htmlWithReplacedCharacters = html;
        if (html) {
          htmlWithReplacedCharacters = html

            .replaceAll(`class="ql-align-center"`, `style="text-align: center"`)
            .replaceAll(
              `class="ql-align-justify"`,
              `style="text-align: justify"`
            )
            .replaceAll(`class="ql-align-right"`, `style="text-align: right"`);

          if (!this.withoutAllReplacements) {
            htmlWithReplacedCharacters = html
              .replaceAll(
                "&lt;partners&gt;Lista partnerów&lt;/partners&gt;",
                "<partners>Lista partnerów</partners>"
              )

              .replaceAll("&lt;hide&gt;", "<hide>")
              // .replaceAll("<p>", "")
              // .replaceAll("</p>", "")
              .replaceAll(
                `</li><li>NESTED-LIST</li>`,
                `<ol style="list-style-type: lower-alpha !important; list-style-position: inside;">`
              )
              .replaceAll(`<li>END-NESTED-LIST</li>`, `</ol></li>`)
              .replaceAll(`<span>`, ``)
              .replaceAll(`</span>`, ``);
          }
        }

        this.$emit("contentchanged", htmlWithReplacedCharacters);
      }
    },
  },

  computed: {
    editor() {
      if (this.$refs.myQuillEditor) {
        return this.$refs.myQuillEditor.quill;
      } else {
        return null;
      }
    },
  },
};
</script>
<style scoped>
.a {
  text-align: right;
}
</style>
